// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"181":"8ac1e736","192":"83397af9","247":"eeeece1b","850":"0f49c6e0"}[chunkId] + ".chunk.js";
};